import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { useSimilarProducts } from '@/composables';
import { type Product as ProductType } from '@webplatform/cms-js-sdk';
import { CdnImg } from '@webplatform/cdn-image';

export type Product = ProductType & {
  image: string;
  status: number;
  external_cf_published_at: string;
};

interface Props {
  product: Product;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductCard',
  props: {
    product: null
  },
  setup(__props: any) {

const props = __props as {
  product: Product;
};


const {
  currentVariation,
  variations,
  similarProducts,
  activeSimilarProduct,
  setVariation,
  setSimilarProduct,
  setProduct,
} = useSimilarProducts();
setProduct(props.product);

const productSlug = computed(
  () => activeSimilarProduct.value?.slug || `/product/${props.product.slug}`,
);

const productImage = computed(
  () =>
    activeSimilarProduct.value?.photo_url ||
    variations?.value?.[currentVariation.value]?.images?.[0],
);

const productSKU = computed(
  () =>
    activeSimilarProduct.value?.sku ||
    variations.value?.[currentVariation.value]?.sku,
);

return { __sfc: true,props, currentVariation, variations, similarProducts, activeSimilarProduct, setVariation, setSimilarProduct, setProduct, productSlug, productImage, productSKU, CdnImg }
}

})